var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-badge',{attrs:{"variant":"secondary"}},[_vm._v(_vm._s(_vm.get_label( _vm.item.modalita_pagamento )))])}
var staticRenderFns = []

export { render, staticRenderFns }